module.exports = __webpack_public_path__ + "static/media/console.1ef144ff.svg";